/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { shareEntity, shareEntityGenerateFromWebpage } from "@insite/client-framework/Services/EmailService";
import { chain, SendDataToApi } from "@insite/client-framework/Store/CommonHandlers/ShareEntity";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = Parameters<typeof SendDataToApi>[0];

// override to disbale the LazyLoad images on PDF
export const MONSendDataToApi = async (props: HandlerType) => {
    const {
        parameter: { generateAttachmentFromWebpage },
        apiParameter,
    } = props;
    const location = getLocation(props.getState());

    props.apiResult = generateAttachmentFromWebpage
        ? await shareEntityGenerateFromWebpage({
              shareEntityModel: props.parameter.shareEntityModel,
              urlPathToLoadForAttachmentHtml: `${location.pathname + location.search}&disableLazyLoad=true`,
          })
        : await shareEntity(apiParameter);
};

replaceInChain(chain, SendDataToApi, MONSendDataToApi);
